module.exports = __webpack_public_path__ + "img/hourglass.0c80c957.png";